import { Box, styled, useTheme } from '@ltvco/refresh-lib/theme';
import { useLocation } from 'react-router-dom';
import { useScreenSize } from '@ltvco/refresh-lib/utils';
import { useBannerLogic } from '@ltvco/refresh-lib/v2';

const AppWrapper = styled('div')<{
  isOnReportView?: boolean;
  isOnChatAIView?: boolean;
  isDesktop?: boolean;
}>(({ theme, isOnChatAIView, isDesktop }) => ({
  margin: '20px 16px 20px 16px',
  marginTop: isOnChatAIView && !isDesktop ? '0' : '80px',
  marginLeft: isOnChatAIView ? '8px' : '16px',
  marginRight: isOnChatAIView ? '8px' : '16px',
  backgroundColor: theme.palette.background.default,
  paddingBottom: theme.spacing(0.25),
  [theme.breakpoints.up('md')]: {
    margin: 0,
  },
}));

export function AppContainer({
  children,
}: {
  children: React.ReactNode | React.ReactNode[];
}) {
  const location = useLocation();
  const theme = useTheme();
  const { isDesktop, isMobile } = useScreenSize();
  const { isUserInTest } = useBannerLogic();
  const isOnReportView = location.pathname.includes('/report/');
  const isOnChatAIView = location.pathname.includes('/bumper-chat');
  const isOnCommunityBuzzView = location.pathname.includes('/community-buzz');
  return (
    <AppWrapper
      id={isUserInTest && isDesktop ? 'app-container' : ''}
      sx={{
        marginX: isOnReportView || isOnCommunityBuzzView ? 0 : null,
        marginY: isOnCommunityBuzzView ? 4 : null,
        paddingBottom: isOnChatAIView ? '0' : '2px',
        height: isOnChatAIView ? '100vh' : 'unset',
        backgroundColor:
          isOnChatAIView && isMobile
            ? theme.palette.background.paper
            : theme.palette.background.default,
      }}
      isOnReportView={isOnReportView}
      isOnChatAIView={isOnChatAIView}
      isDesktop={isDesktop}
    >
      <Box>{children}</Box>
    </AppWrapper>
  );
}
